<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12">
    <path d="M10 5 5 0 0 5M0 7l5 5 5-5" fill="#c7c7c6"/>
  </svg>
</template>
